<template>
  <div class="page-contact">
    <main class="main">
      <div class="main-content">
        <breadcrumbs></breadcrumbs>

        <article>
          <h1>Contact</h1>
          <div v-if="contact" v-html="contact.text" class="rte"></div>
          <form v-on:submit.prevent="checkForm" @submit="checkForm">
            <div v-if="contactForm.errors.length" class="error">
              <b>Veuillez corriger les erreurs suivantes :</b>
              <ul>
                <li v-for="(error, i) in contactForm.errors" :key="i">
                  {{ error }}
                </li>
              </ul>
            </div>

            <div>
              <label for="name">Nom</label>
              <br />
              <input
                id="name"
                v-model="contactForm.fields.name.value"
                type="text"
                name="name"
              />
            </div>

            <div>
              <label for="email">{{ contactForm.fields.email.title }}</label>
              <br />
              <input
                id="email"
                v-model="contactForm.fields.email.value"
                type="email"
                name="email"
              />
            </div>

            <div>
              <label for="subject">Sujet</label>
              <br />
              <input
                id="subject"
                v-model="contactForm.fields.subject.value"
                type="text"
                name="subject"
              />
            </div>

            <div>
              <label for="message">Message</label>
              <br />
              <textarea
                id="message"
                v-model="contactForm.fields.message.value"
                name="message"
              ></textarea>
            </div>

            <div>
              <input type="submit" value="Envoyer" />
            </div>
          </form>
        </article>
      </div>
    </main>
  </div>
</template>

<script>
import Contact from "@/api/contact.js";
import Breadcrumbs from "@/components/Breadcrumbs";

export default {
  name: "Contact",
  components: { Breadcrumbs },

  data() {
    return {
      busy: false,
      contact: {},
      contactForm: {
        errors: [],
        fields: {
          name: {
            title: "Nom",
            value: null,
          },
          email: {
            title: "Adresse email",
            value: null,
          },
          subject: {
            title: "Sujet",
            value: null,
          },
          message: {
            title: "Message",
            value: null,
          },
        },
      },
    };
  },

  created() {
    Contact.retrieve(1, false)
      .then((response) => {
        this.contact = response;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.contact = null;
        }
      });
  },

  methods: {
    checkForm() {
      this.contactForm.errors = [];

      for (let field in this.contactForm.fields) {
        if (!this.contactForm.fields[field].value) {
          this.contactForm.errors.push(
            'Champ "' + this.contactForm.fields[field].title + '" requis.'
          );
        }
      }

      if (!this.contactForm.errors.length && this.busy === false) {
        this.busy = true;
        let params = {};
        for (let field in this.contactForm.fields) {
          params[field] = this.contactForm.fields[field].value;
        }

        Contact.sendMail(params)
          .then(() => {
            // reset fields value
            for (let field in this.contactForm.fields) {
              this.contactForm.fields[field].value = null;
            }
            this.flashSuccess("Message envoyé avec succès");
            this.busy = false;
          })
          .catch(() => {
            this.flashError("Un problème est survenu");
            this.busy = false;
          });
      }
    },
  },
};
</script>
